<template>
    <rkm-modal
        :loading="loading"
        ref="Modal"
        :title="`Profissional`"
        extraLarge
    >

        <rkm-alert v-if="equipe != null && equipe.areaDescricao">
            <strong>
                INE: {{ equipe.numeroIne ? equipe.numeroIne.padStart(10, '0') : '' }} - Área: {{ equipe.areaDescricao }} - Microárea:
                    {{ equipe.microareaDescricao }}
            </strong>
        </rkm-alert>

        <rkm-alert v-if="equipe != null && !equipe.areaDescricao">
            <strong>
                INE: {{ equipe.numeroIne ? equipe.numeroIne.padStart(10, '0') : '' }} - Microárea:
                    {{ equipe.microareaDescricao }}
            </strong>
        </rkm-alert>

        <template v-if="equipe != null">

            <rkm-form
                ref="FormProfissional"
                show-legend
            >

                <rkm-row class="flex-nowrap">

                    <rkm-col class="flex-grow-1">

                        <rkm-form-input-autocomplete
                            :repository="repositories.usuario"
                            :requestQueryStringParams="autocompleteRequestParams.usuario"
                            :searchFields="fields.autocomplete.usuario"
                            :validations="validations.usuario"
                            text-field="cidadaoNome"
                            label="Profissional"
                            placeholder="Digite o nome ou número do conselho profissional"
                            v-model="model.usuario"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-0 text-nowrap">

                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="getOcupacoes()"
                        >
                            Incluir
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <rkm-table
                :items="equipe.usuarios"
                :fields="fields.table"
                ref="Table"
                sortBy="nome"
            >

            <template v-slot:cell(ocupacao)="row">
                <rkm-button
                    small
                    color="primary"
                    v-rkm-popover.hover.left="
                        {
                            title: 'Ocupações',
                            html: true,
                            content: row.item.lotacoes.length > 0
                            ?  row.item.lotacoes
                            : 'Não há registros de ocupações para o profissional na unidade da equipe selecionada'
                        }
                    "
                >
                    <rkm-icon icon="th" />
                </rkm-button>

            </template>

                <template v-slot:cell(actions)="{ item }">

                    <rkm-button
                        v-if="!item.ativo"
                        @click="handleBlock(item)"
                        color="success"
                        title="Ativar"
                        small
                    >
                        <rkm-icon icon="check-circle"/>
                    </rkm-button>

                    <rkm-button
                        v-if="item.ativo"
                        @click="handleBlock(item)"
                        color="dark"
                        title="Inativar"
                        small
                    >
                        <rkm-icon icon="ban"/>
                    </rkm-button>

                    <rkm-button
                        @click="handleDestroy(item)"
                        color="danger"
                        title="Excluir"
                        small
                    >
                        <rkm-icon icon="trash"/>
                    </rkm-button>
                </template>
            </rkm-table>
        </template>

        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>

// Vuex.
import { mapGetters, mapActions } from 'vuex'

// Mixins
import { repository, error, object, stringCase } from "@/mixins";

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        ...mapActions([
            'setShowExitFormConfirmation',
            'unsetShowExitFormConfirmation'
        ]),
        validations() {

            return {
                usuario: { required: true },
            }
        },
        fields() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ],
                },
                table: [
                    { key: 'nome', label: 'Profissional', sortable: true, },
                    { key: 'ocupacao', label: 'CBO', class: 'col-min text-center', sortable: true, },
                    { key: 'actions', label: 'Ações', class: 'col-min', },
                ]
            }
        },
        autocompleteRequestParams() {
            return {
                usuario: {
                    with_not_regularized: true,
                    with_lotacoes: true,
                },
            }
        },
    },
    data: () => ({
        equipe: null,
        usuariosEquipe: [],
        model: {
            usuario: null,
        },
    }),
    created() {
        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            parametrizacao: this.getConectaSusRepository('atencaoBasica.parametrizacao')
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {

            this.equipe = item

            this.limpaFormulario()

            this.$refs.Modal.show()
        },
        add() {
            const usuario = this.clone(this.model.usuario)

            if (this.equipe.usuarios.find(u => u.id === usuario.id)) {

                this.limpaFormulario()

                this.showValidationNotification("Profissional já cadastrado.")
                return
            }

            const param = {
                id: usuario.id,
                nome: usuario.cidadaoNome,
                lotacoes: usuario.lotacoes,
                ativo: true
            }

            this.equipe.usuarios.push(param)

            this.limpaFormulario()
        },
        getOcupacoes() {

            this.setLoading()

            this.repositories.parametrizacao.getOcupacoes({
                usuario_id: this.model.usuario.id,
                infraestrutura_id: this.equipe.infraestruturaId
            })
                .then(({ data }) => {

                    this.model.usuario.lotacoes = data

                    this.$nextTick()
                        .then(() => this.$refs.FormProfissional.validate(this.add))
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        limpaFormulario() {

            this.model.usuario = null,

            this.$nextTick()
                .then(() => this.$refs.FormProfissional.resetValidator())
        },
        handleBlock(item) {

            const objIndex = this.equipe.usuarios.findIndex(u => u.id === item.id)

            this.equipe.usuarios[objIndex].ativo = ! this.equipe.usuarios[objIndex].ativo
        },
        handleDestroy(item) {

            const objIndex = this.equipe.usuarios.findIndex(u => u.id === item.id)

            const removerProfissional = async () =>  this.equipe.usuarios.splice(objIndex, 1)

            this.showDeleteConfirmation(
                `Deseja realmente excluir o profissional da equipe?`,
                removerProfissional,
                this.handleError
            )

            this.limpaFormulario()
        },
        cancel() {

            this.$refs.Modal.hide()
        },
    },
    mixins: [ repository, error, object, stringCase ],
    props: {
        data: { type: Object, required: true, },
    }
}
</script>

<style scoped>
.popover{
    max-width: 70%;
    width: auto;
}
</style>